import Vue from 'vue'

/**
 * Default round for ROM values
 * @name Consistently round ROM values
 * @returns {number} Rounded ROM value
 */

const roundROM = (ROM) => {
  return Math.floor(ROM)
}

Vue.filter('roundROM', roundROM)

export default roundROM
